// Map between the input field names and the messages to be shown if the field is empty or the value is invalid
const NAME_TO_ERR_MSG_MAP = {
    "contact[first_name]": 'First Name is required',
    "contact[last_name]": 'Last Name is required',
    "contact[interest]": "Interest is required",
    "contact[zip]": "Zip code is required",
    "contact[email]": "Please enter a valid email"
}

// Different possible input types
const INPUT_TYPES = {
    email: "email",
    text: "text"
}

/**
 * Handles email validation
 * @param {string | undefined} email The email to be validated
 * @returns a boolean indicating if the email is valid or not
 */
const validateEmail = (email) => (
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
).test(email.toString());

/**
 * Handles showing/erasing the error messages for the input
 * @param {HTMLInputElement} input The input to be validated
 * @param {boolean} isValid A boolean indicating if the input is valid
 */
const updateDOM = (input, isValid) => {
    const parent = input.parentElement;
    const error = parent.querySelector('.helper-text');
    const name = input.name;

    // Erase the error message if it is valid
    if(isValid){
        error.innerText = "";
        error.classList = "helper-text";
        return;
    }

    // Show the error message
    error.innerText = NAME_TO_ERR_MSG_MAP[name];
    error.classList = "helper-text helper-text--visible";
}

/**
 * Handles validating the input fields
 * @param {HTMLInputElement} input The input to be validated
 * @returns a boolean denoting if the input is valid or not
 */
const validateInput = (input) => {
    const type = input.type;
    const value = input.value;
   
    switch(type){
        case INPUT_TYPES.text: {
            const isValid = !!value;
            updateDOM(input, isValid);
            break;
        }
        case INPUT_TYPES.email: {
            const isValid = validateEmail(value);
            updateDOM(input, isValid);
            break;
        }
    }
}

const forms = document.querySelectorAll('.js-contact-form');

// TODO: Handle form submission
forms.forEach(form => (
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        console.log('prevented');

        // Validate all the inputs
        form.querySelectorAll('input').forEach(input => validateInput(input));
    })
));

// Generate year for copyright
const copyrightYearContainers = document.querySelectorAll(".js-year");
copyrightYearContainers.forEach(copyrightYearContainer => (copyrightYearContainer.innerText = new Date().getFullYear()));
